import AuthView from '@/views/AuthView/AuthView.vue'

const adminChildrenRoutes = [
  {
    path: 'companies',
    name: 'adminCompanies',
    meta: { requiresAdmin: true, withSearch: true },
    component: () => import('@/modules/admin/views/AdminCompaniesView/AdminCompaniesView.vue'),
  },
  {
    path: 'companies/:id',
    name: 'adminCompany',
    meta: { requiresAdmin: true },
    component: () => import('@/modules/admin/views/AdminCompanyView/AdminCompanyView.vue'),
  },
  {
    path: 'partners',
    name: 'adminPartners',
    meta: { requiresAdmin: true, withSearch: true },
    redirect: { name: 'adminPartnersList' },
    component: () => import('@/modules/admin/views/AdminPartnersView/AdminPartnersView.vue'),
    children: [
      {
        path: 'list',
        name: 'adminPartnersList',
        meta: { requiresAdmin: true, tab: 'list' },
        component: () =>
          import('@/modules/admin/views/AdminPartnersListView/AdminPartnersListView.vue'),
      },
      // {
      //   path: 'payments',
      //   name: 'adminPartnersPayments',
      //   meta: { requiresAdmin: true, tab: 'payments' },
      //   component: () =>
      //     import('@/modules/admin/views/AdminPartnersPaymentsView/AdminPartnersPaymentsView.vue'),
      // },
    ],
  },
  {
    path: 'partners/create',
    name: 'adminPartnerCreate',
    meta: { requiresAdmin: true },
    component: () => import('@/modules/admin/views/AdminPartnerView/AdminPartnerView.vue'),
  },
  {
    path: 'partners/:id',
    name: 'adminPartnerEdit',
    meta: { requiresAdmin: true },
    component: () => import('@/modules/admin/views/AdminPartnerView/AdminPartnerView.vue'),
  },
  {
    path: 'partners/:partnerId/company/add',
    name: 'adminPartnerCompanyAdd',
    meta: { requiresAdmin: true },
    component: () =>
      import('@/modules/admin/views/AdminPartnerCompanyView/AdminPartnerCompanyView.vue'),
  },
  {
    path: 'partners/:partnerId/company/:companyId',
    name: 'adminPartnerCompanyEdit',
    meta: { requiresAdmin: true },
    component: () =>
      import('@/modules/admin/views/AdminPartnerCompanyView/AdminPartnerCompanyView.vue'),
  },
  {
    path: 'partners/:partnerId/payment/add',
    name: 'adminPartnerPaymentAdd',
    meta: { requiresAdmin: true },
    component: () =>
      import('@/modules/admin/views/AdminPartnerPaymentView/AdminPartnerPaymentView.vue'),
  },
  {
    path: 'partners/:partnerId/payment/:paymentId',
    name: 'adminPartnerPaymentEdit',
    meta: { requiresAdmin: true },
    component: () =>
      import('@/modules/admin/views/AdminPartnerPaymentView/AdminPartnerPaymentView.vue'),
  },
  {
    path: 'finance',
    name: 'adminFinance',
    meta: { requiresAdmin: true },
    component: () => import('@/modules/admin/views/AdminFinanceView/AdminFinanceView.vue'),
  },
  {
    path: 'settings',
    name: 'adminSettings',
    meta: { requiresAdmin: true },
    component: () => import('@/modules/admin/views/AdminSettingsView/AdminSettingsView.vue'),
  },
]

export default [
  {
    path: '/admin',
    name: 'adminRoot',
    meta: { layout: 'Main' },
    redirect: { name: 'adminCompanies' },
    children: adminChildrenRoutes,
  },
  {
    path: '/admin/login',
    name: 'adminLogin',
    component: AuthView,
    meta: { layout: 'Auth' },
  },
]
